import React from 'react';
import { branch } from 'baobab-react/higher-order';

import BLOCKS from '@store/blocks';

import Block from '@components/common/block';
import Input from '@components/common/input';
import IconButton from "@components/common/icon-button";

import { OPEN_POPUP } from './actions';

import styles from './index.module.css';

class UserInfoBlock extends React.Component {
  constructor(props) {
    super(props);

    this.openBudget = () => props.dispatch(OPEN_POPUP, 'budget');
    this.openDocuments = () => props.dispatch(OPEN_POPUP, 'documents');
  }

  render() {
    return (<Block className={styles.block} header='User Info'>
      <div className={styles.container}>
        <div className={styles.line}>
          <div className={`${styles.icon} ${styles.user}`}/>
          <Input className={styles.input} value={this.props.username} disabled={true}/>
        </div>
        <div className={styles.line}>
          <div className={styles.buttonContainer}><IconButton onClick={ this.openBudget} icon='coin' className={styles.buttonIcon} /></div>
          <Input className={styles.input} value={'$' + this.props.balance} disabled={true}/>
        </div>
        <div className={styles.line}>
          <div className={styles.buttonContainer}><IconButton onClick={ this.openDocuments } icon='file' className={styles.buttonIcon} /></div>
          <span>Documents</span>
        </div>
      </div>
    </Block>);
  }
}

UserInfoBlock.propTypes = {
};

export default branch({
  balance: BLOCKS.USER_INFO.BALANCE,
  username: BLOCKS.USER_INFO.USERNAME
}, UserInfoBlock);